// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'

import Header from './components/header.jsx';
import Footer from './components/footer.jsx';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';

class Project extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeMenu: props.activeMenu,//liuxue,uk,usa,au,language,culture
        };


    }

    componentDidMount() {
        const { match } = this.props;
        const { id } = match.params;


    }


    render() {
        let { universitiyInfo } = this.state;
        return (
            <div className='dv_project_body_left'>
                <div className='dv_project_fixed_left'>
                    <Link to={`/Project/Ma`} className={this.state.activeMenu == '1' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>马来西亚硕博</Link>
                    <Link to={`/Project/Es`} className={this.state.activeMenu == '2' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>西班牙本硕</Link>
                    <Link to={`/Project/Fr`} className={this.state.activeMenu == '3' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>法国本硕</Link>
                    <Link to={`/Project/Sg`} className={this.state.activeMenu == '4' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>新加坡硕士</Link>
                    <Link to={`/Project/Au`} className={this.state.activeMenu == '5' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>澳洲</Link>
                </div>
            </div>
        );
    }
}

export default withRouter(Project);